import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';

@Injectable({
  providedIn: 'root',
})
export class KeycloakAuthGuard {
  constructor(
    private router: Router,
    private keycloakService: KeycloakService
  ) {}

  async canActivate(): Promise<boolean> {
    if (await this.keycloakService.isLoggedIn()) {
      return true;
    }

    this.keycloakService.login();
    return false;
  }
}
